import { pt } from '../copy';
import type { StoredJourney } from '../lib/storage';

type HistoryRailProps = {
  items: StoredJourney[];
  onPick: (j: StoredJourney) => void;
  onClear: () => void;
};

function toThumbnailSrc(item: StoredJourney): string | null {
  const frame = item.frames[0];
  if (!frame) {
    return null;
  }

  return `data:image/png;base64,${frame.b64}`;
}

export default function HistoryRail({ items, onPick, onClear }: HistoryRailProps) {
  return (
    <div className="space-y-3 rounded-3xl border border-white/10 bg-white/5 p-4 backdrop-blur-xl">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-sm font-medium text-white/80">{pt.historyTitle}</h2>
        {items.length > 0 ? (
          <button
            className="rounded-full bg-white/10 px-3 py-1.5 text-xs font-medium uppercase tracking-[0.2em] text-white/70 transition hover:bg-white/15"
            type="button"
            onClick={onClear}
          >
            {pt.historyClear}
          </button>
        ) : null}
      </div>

      {items.length === 0 ? (
        <p className="text-sm text-white/45">{pt.historyEmpty}</p>
      ) : (
        <div className="-mx-1 flex gap-3 overflow-x-auto px-1 pb-1">
          {items.map((item) => {
            const thumbnailSrc = toThumbnailSrc(item);

            return (
              <button
                key={item.id}
                className="w-44 shrink-0 overflow-hidden rounded-2xl border border-white/10 bg-black/25 text-left transition hover:border-white/20 hover:bg-white/10"
                type="button"
                onClick={() => onPick(item)}
              >
                {thumbnailSrc ? (
                  <img
                    alt={item.location}
                    className="h-24 w-full object-cover"
                    src={thumbnailSrc}
                  />
                ) : (
                  <div className="flex h-24 w-full items-center justify-center bg-white/5 text-xs uppercase tracking-[0.24em] text-white/35">
                    {pt.historyNoPreview}
                  </div>
                )}
                <div className="space-y-1 p-3">
                  <p className="text-sm font-medium text-white">{item.location}</p>
                  <p className="text-xs text-white/45">
                    {new Intl.DateTimeFormat('pt-BR', {
                      dateStyle: 'short',
                      timeStyle: 'short',
                    }).format(item.createdAt)}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
